import React from 'react';

function AppTitle(){
    return (
        <div>
              <p>
                Register to be the first to know when the GNPC scholarship is available
            </p>
        </div>
    );

}

export default AppTitle;



// WEBPACK FOOTER //
// ./src/components/AppTitle.js